import Cookies from 'js-cookie'

export const TOUCH_FIRST_COOKIE = 'mx_touch_first'
export const TOUCH_LAST_COOKIE = 'mx_touch_last'
export const RENSHU_CID_COOKIE = 'mx_renshu_cid'

const COOKIE_EXPIRY_DAYS = 400
// Matches Renshu's own 30-day revenue attribution window.
const RENSHU_CID_EXPIRY_DAYS = 30
const MAX_VALUE_LENGTH = 200

const PARAM_KEYS = {
  utm_source: 'us',
  utm_medium: 'um',
  utm_campaign: 'uc',
  utm_content: 'un',
  utm_term: 'ut',
  gclid: 'g',
  fbclid: 'f',
  ttclid: 't',
  msclkid: 'm',
}

const referrerHostname = () => {
  try {
    if (!document.referrer) return ''
    return new URL(document.referrer).hostname
  } catch {
    return ''
  }
}

const buildPayload = () => {
  const params = new URLSearchParams(window.location.search)
  const payload = {}
  let hasParams = false

  Object.entries(PARAM_KEYS).forEach(([param, key]) => {
    const value = params.get(param)?.trim()
    if (value) {
      payload[key] = value.slice(0, MAX_VALUE_LENGTH)
      hasParams = true
    }
  })

  const referrer = referrerHostname()
  if (referrer) payload.r = referrer

  payload.lp = window.location.pathname
  payload.ts = Math.floor(Date.now() / 1000)

  return { payload, hasParams }
}

const writeCookie = (name, value, expires = COOKIE_EXPIRY_DAYS) => {
  try {
    Cookies.set(name, value, {
      expires,
      domain: '.maximustribe.com',
      secure: true,
      sameSite: 'Lax',
    })
  } catch {
    return
  }
}

// Renshu click id from a shoguntrk email link. Latest click wins, and Rails reads
// the cookie at registration to attribute the order server-side (MAX-12434).
const captureRenshuClickId = () => {
  const cid = new URLSearchParams(window.location.search).get('cid')?.trim()
  if (cid) {
    writeCookie(RENSHU_CID_COOKIE, cid.slice(0, MAX_VALUE_LENGTH), RENSHU_CID_EXPIRY_DAYS)
  }
}

export const captureAttributionCookies = () => {
  if (typeof window === 'undefined') return

  const { payload, hasParams } = buildPayload()
  const value = JSON.stringify(payload)

  if (!Cookies.get(TOUCH_FIRST_COOKIE)) {
    writeCookie(TOUCH_FIRST_COOKIE, value)
  }

  if (hasParams) {
    writeCookie(TOUCH_LAST_COOKIE, value)
  }

  captureRenshuClickId()
}
